import React, { Component } from "react";
import Page from "../../components/Page";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import {
  Button,
  Table,
  Breadcrumb,
  Segment,
  Modal,
  ModalActions,
  ModalContent,
  Icon,
  Input,
  Message,
} from "semantic-ui-react";
import _ from "lodash";
import { getDialogtab, post, postlocal } from "../../util/api";
import * as XLSX from "xlsx";

class ReviewHelper extends Component {
  state = {
    loading: true,
    data: [],
    modal: false,
    firm_id: null,
    verified: [],
  };

  componentDidMount() {
    let { product } = this.props;
    let { personalize } = product;
    let { settings } = personalize;
    let { trendyol } = settings;
    this.setState({
      firm_id: trendyol && trendyol.firm_id,
      sitemap: trendyol && trendyol.sitemap_url,
      settings: trendyol,
    });
    setTimeout(() => this.fetchComments(), 100);
  }

  fetchComments = () => {
    const { firm_id } = this.state;
    let { product } = this.props;
    let { personalize } = product;
    let { id } = personalize;
    if (!firm_id) this.setState({ loading: false });
    else {
      getDialogtab(
        `https://micro.collectaction.com/api/comments/settings/${firm_id}/${id}`
      ).then((res) => {
        this.setState({
          loading: false,
          data: res && res.data,
          pairs: res && res.pairs,
        });
      });
    }
  };

  openModal = (url) => {
    this.setState({ modal: true, changed_url: url });
  };

  pairsProduct = (trendyol_url) => {
    let { changed_url, firm_id } = this.state;
    let { product } = this.props;
    let { personalize } = product;
    let { id } = personalize;
    postlocal(
      `https://micro.collectaction.com/api/comments/settings/set/${firm_id}/${id}`,
      {
        origin_url: changed_url,
        trendyol_url,
      }
    ).then((res) => {
      if (res.data.success) {
        this.fetchComments();
        this.setState({ modal: false, editingSku: null });
      }
    });
  };

  handleFileUpload = (event) => {
    const file = event.target.files[0];
    this.setState({ file });

    const reader = new FileReader();
    reader.onload = (e) => {
      // eslint-disable-next-line no-undef
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const excelData = XLSX.utils.sheet_to_json(worksheet);

      if (
        !excelData ||
        !excelData[0] ||
        (excelData[0] && !excelData[0].trendyol_url) ||
        (excelData[0] && !excelData[0].origin_url)
      ) {
        //todo
        this.setState({ alert_excel: true });
      } else {
        this.setState({ excelData });
      }
    };
    reader.readAsArrayBuffer(file);
  };

  deleteProduct = (trendyol_url, origin_url) => {
    let { firm_id } = this.state;
    let { product } = this.props;
    let { personalize } = product;
    let { id } = personalize;
    postlocal(
      `https://micro.collectaction.com/api/comments/settings/delete/${firm_id}/${id}`,
      {
        origin_url,
        trendyol_url,
      }
    ).then((res) => {
      if (res.data.success) {
        this.fetchComments();
        this.setState({ modal: false, editingSku: null });
      }
    });
  };

  searchLink = (type) => {
    let { _value, _value2, data } = this.state;

    let result = [];
    switch (type) {
      case "origin_url":
        if (!_value || _value.trim() === "") {
          this.setState({ new_origin_url: null, new_trendyol_url: null });
          return;
        }
        result = data.sitemap_list.filter((item) => item.includes(_value));
        this.setState({ new_origin_url: result });
        break;
      case "trendyol_url":
        if (!_value2 || _value2.trim() === "") {
          this.setState({ new_origin_url: null, new_trendyol_url: null });
          return;
        }
        result = data.trendyol_list.filter((item) => item.includes(_value2));
        this.setState({ new_trendyol_url: result });
        break;
      default:
        break;
    }
  };

  setSettings = async () => {
    let { firm_id, sitemap } = this.state;
    this.setState({ loading: true });
    post("/personalize/createTrendyol", { firm_id, sitemap_url: sitemap }).then(
      () => {
        this.setState({ loading: false });
        window.location.reload();
      }
    );
  };

  pairsMultiProduct = async () => {
    let { firm_id, excelData } = this.state;
    let { product } = this.props;
    let { personalize } = product;
    let { id } = personalize;
    if (!excelData) this.setState({ excelData: null });
    if (excelData && excelData.length > 200) {
      for (let i = 0; i < excelData.length; i += 100) {
        const chunk = excelData.slice(i, i + 100);

        await postlocal(
          `https://micro.collectaction.com/api/comments/settings/multiset/${firm_id}/${id}`,
          {
            links: chunk,
          }
        );
      }
      this.fetchComments();
      this.setState({ modal: false, editingSku: null, excelData: null });
    }
  };

  render() {
    let {
      loading,
      data,
      new_origin_url,
      new_trendyol_url,
      settings,
      firm_id,
      sitemap,
      alert_excel,
      excelData,
      pairs,
    } = this.state;
    let { t } = this.props;
    let mapped_data =
      new_origin_url && new_origin_url.length > 0
        ? new_origin_url
        : data && data.sitemap_list;

    let mapped_trendyol_data =
      new_trendyol_url && new_trendyol_url.length > 0
        ? new_trendyol_url
        : data && data.trendyol_list;

    if (loading) {
      return (
        <Page
          icon="chart line"
          title={t("trendyolImprovedProductMatching")}
          extra={
            <div
              css={`
                margin-left: auto;
              `}
            ></div>
          }
        >
          <Page.Loader key="loader" />
        </Page>
      );
    } else {
      return (
        <Page
          icon="chart line"
          title={t("trendyolImprovedProductMatching")}
          header={
            <Breadcrumb size="big">
              <Breadcrumb.Section>
                {t("trendyolImprovedProductMatching")}
              </Breadcrumb.Section>
            </Breadcrumb>
          }
        >
          <Page.Wrap>
            {!settings ? (
              <Segment>
                <div>
                  <Input
                    style={{ width: "100%" }}
                    label={t("trendyolFirmId")}
                    placeholder="999999"
                    value={firm_id}
                    className="tiny"
                    onChange={(e) => {
                      this.setState({ firm_id: e.target.value });
                    }}
                    autoFocus={true}
                  />
                </div>
                <div style={{ marginTop: 10 }}>
                  <Input
                    label={t("sitemapLink")}
                    style={{ width: "100%" }}
                    placeholder="https://www.collectaction.com/sitemap"
                    value={sitemap}
                    className="tiny"
                    onChange={(e) => {
                      this.setState({ sitemap: e.target.value });
                    }}
                    autoFocus={true}
                  />
                </div>
                <Button
                  color="blue"
                  disabled={!sitemap || !firm_id ? true : false}
                  style={{
                    marginTop: 10,
                    marginLeft: "auto",
                    display: "block",
                  }}
                  onClick={() => this.setSettings()}
                >
                  {t("saveAndAnalyze")}
                </Button>
              </Segment>
            ) : (
              <>
                <Segment>
                  <h3>{t("products")}</h3>

                  <Input
                    placeholder={t("searchBrandProducts")}
                    value={this.state._value}
                    className="tiny"
                    onChange={(e) => {
                      this.setState({ _value: e.target.value });
                    }}
                    autoFocus={true}
                    action={
                      <Button
                        basic
                        icon
                        loading={this.state.loading}
                        onClick={() => {
                          this.searchLink("origin_url");
                        }}
                      >
                        <Icon name="angle right" />
                      </Button>
                    }
                  />
                  <div
                    style={{
                      maxHeight: "500px",
                      overflow: "auto",
                      marginTop: 10,
                    }}
                  >
                    <Table celled>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell>{"Id"}</Table.HeaderCell>
                          <Table.HeaderCell>{t("Url")}</Table.HeaderCell>
                          <Table.HeaderCell>{t("Status")}</Table.HeaderCell>
                          <Table.HeaderCell>{t("process")}</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {_.map(mapped_data, (it, i) => (
                          <Table.Row>
                            <Table.Cell>{i}</Table.Cell>
                            <Table.Cell>{it}</Table.Cell>
                            <Table.Cell>
                              {(data &&
                                data.verified &&
                                data.verified.length > 0 &&
                                _.find(
                                  data.verified,
                                  (e) => e.origin_url == it
                                ) &&
                                "true") ||
                                "false"}
                            </Table.Cell>
                            <Table.Cell>
                              <Button
                                color="blue"
                                content={t("select")}
                                icon="save"
                                disabled={
                                  _.find(
                                    data.verified,
                                    (e) => e.origin_url == it
                                  )
                                    ? true
                                    : false
                                }
                                onClick={() => this.openModal(it)}
                              />
                            </Table.Cell>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                  </div>
                </Segment>
                <Segment>
                  <h3>{t("pairs")}</h3>
                  <div style={{ paddingTop: 10 }}>
                    <h4 style={{ margin: 0 }}>{t("pairsWithExcel")}</h4>
                    <input
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={this.handleFileUpload}
                      style={{ marginTop: "10px" }}
                    />
                  </div>
                  {alert_excel ? (
                    <Message
                      warning
                      icon="warning"
                      header={t("addedUnspportedFormat")}
                      content={<span>{t("trendyolFormatDesc")}</span>}
                    />
                  ) : excelData && excelData.length > 0 ? (
                    <>
                      <Button
                        color="blue"
                        style={{
                          marginTop: 10,
                          display: "block",
                        }}
                        onClick={() => this.pairsMultiProduct()}
                      >
                        {t("pair")}
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                  {console.log("data ", data)}
                  {pairs && pairs.length > 0 ? (
                    <div
                      style={{
                        maxHeight: "500px",
                        overflow: "auto",
                        marginTop: 10,
                      }}
                    >
                      <Table celled>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell>{t("siteUrl")}</Table.HeaderCell>
                            <Table.HeaderCell>
                              {t("trendyolUrl")}
                            </Table.HeaderCell>
                            <Table.HeaderCell>{t("process")}</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          {_.map(pairs, (it, i) => (
                            <Table.Row key={"verified" + i}>
                              <Table.Cell>{it.origin_url}</Table.Cell>
                              <Table.Cell>{it.trendyol_url}</Table.Cell>
                              <Table.Cell>
                                <Button
                                  color="blue"
                                  content={t("Delete")}
                                  icon="save"
                                  onClick={() =>
                                    this.deleteProduct(
                                      it.trendyol_url,
                                      it.origin_url
                                    )
                                  }
                                />
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </div>
                  ) : (
                    <>{t("noMatchedProductsFound")}</>
                  )}
                </Segment>
              </>
            )}
          </Page.Wrap>

          {this.state.modal && (
            <Modal onClose={() => this.setState({ modal: null })} open={true}>
              <Modal.Header>{t("trendyolProducts")}</Modal.Header>
              <ModalContent
                style={{
                  maxHeight: "350px",
                  height: " 350px",
                  overflow: "overlay",
                }}
              >
                <div style={{ marginBottom: 20 }}>
                  {t("selectTrendyolForPairs")}
                </div>
                <Input
                  placeholder={t("searchTrendyolProducts")}
                  value={this.state._value2}
                  className="tiny"
                  onChange={(e) => {
                    this.setState({ _value2: e.target.value });
                  }}
                  autoFocus={true}
                  action={
                    <Button
                      basic
                      icon
                      loading={this.state.loading}
                      onClick={() => {
                        this.searchLink("trendyol_url");
                      }}
                    >
                      <Icon name="angle right" />
                    </Button>
                  }
                />
                <div style={{ marginTop: 10 }}>
                  <Table celled>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>{"Id"}</Table.HeaderCell>
                        <Table.HeaderCell>{t("Url")}</Table.HeaderCell>
                        <Table.HeaderCell>{t("Status")}</Table.HeaderCell>
                        <Table.HeaderCell>{t("process")}</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {_.map(mapped_trendyol_data, (it, i) => (
                        <Table.Row>
                          <Table.Cell>{i}</Table.Cell>
                          <Table.Cell>{it}</Table.Cell>
                          <Table.Cell>
                            {(data &&
                              data.verified &&
                              data.verified.length > 0 &&
                              _.find(
                                data.verified,
                                (e) => e.origin_url == it
                              ) &&
                              "true") ||
                              "false"}
                          </Table.Cell>
                          <Table.Cell>
                            <Button
                              color="blue"
                              content={t("pair")}
                              icon="save"
                              disabled={
                                _.find(
                                  data.verified,
                                  (e) => e.trendyol_url == it
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => this.pairsProduct(it)}
                            />
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                </div>
              </ModalContent>
              <ModalActions>
                <Button
                  color="black"
                  onClick={() => this.setState({ modal: null })}
                >
                  {t("close")}
                </Button>
              </ModalActions>
            </Modal>
          )}
        </Page>
      );
    }
  }
}

const stateToProps = (state) => ({
  access: state.access,
  product: state.product,
  location: state.router.location,
});

export default connect(stateToProps)(withTranslation()(ReviewHelper));
